import React from 'react'
import { Badge, Button, Checkbox } from '../../../ui'
import { AlertTriangle, Check } from 'lucide-react'
import { coberturaDeGrupo, resumenCobertura } from '../../../../lib/planCobertura'

// El aviso de faltantes es el reemplazo del vinculo vivo: nadie recibe cargos
// solo, pero tampoco se queda olvidado quien entro al grupo despues.
//
// Vista de presentacion: no consulta la base de datos ni maneja el estado de la
// seleccion (eso vive en el orquestador). Sin tabla de escritorio: cada renglon
// es una sola linea flexible que no se desborda, asi que no hay riesgo de scroll
// horizontal en movil (ver ux-rules #11).
// Sin caso vacio propio: el orquestador ya intercepta grupos.length === 0 antes
// de montar esta vista (sabe si es "sin filtros que coincidan" o "temporada sin
// padron" y lo dice mejor de lo que podriamos decir aqui a ciegas).
const VistaGrupos = ({
  grupos, inscritosPorGrupo, planId = null, planesDe = {},
  seleccion = new Set(), onToggle, onAsignarFaltantes,
}) => (
  <ul className="divide-y divide-border">
    {grupos.map((g) => {
      const c = coberturaDeGrupo({ inscritosDelGrupo: inscritosPorGrupo[g.id] || [], planId, planesDe })
      const seleccionable = c.inscritos > 0
      return (
        <li
          key={g.id}
          onClick={() => seleccionable && onToggle(g.id)}
          className={`flex min-h-11 items-start gap-3 rounded-md px-1 py-3 ${
            seleccionable ? 'cursor-pointer hover:bg-muted/50' : ''
          }`}
        >
          {/* Toda la fila es el area tactil (ux-rules #11); el propio Checkbox
              detiene la propagacion para no disparar el toggle dos veces. */}
          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={seleccion.has(g.id)}
              onCheckedChange={() => onToggle(g.id)}
              aria-label={`Seleccionar ${g.nombre_del_grupo}`}
              disabled={!seleccionable}
            />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium">{g.nombre_del_grupo}</p>
            <p className="text-xs text-muted-foreground">
              {resumenCobertura(c, { planId, sustantivo: 'inscritos' })}
            </p>
          </div>
          {c.faltantes.length > 0 && (
            <Button
              variant="outline"
              size="sm"
              className="shrink-0"
              onClick={(e) => { e.stopPropagation(); onAsignarFaltantes(g.id, c.faltantes) }}
              title={`Asignar el plan a los ${c.faltantes.length} que aún no lo tienen`}
            >
              <AlertTriangle className="mr-1 h-3.5 w-3.5" />
              Asignar a {c.faltantes.length}
            </Button>
          )}
          {c.completo && (
            <Badge variant="secondary" className="shrink-0">
              <Check className="mr-1 h-3 w-3" />Completo
            </Badge>
          )}
        </li>
      )
    })}
  </ul>
)

export default VistaGrupos
